import { Tooltip } from "@mui/material"
import React from "react"

const GroupIcon = (props) => {
  return (
    <Tooltip title="Agrupar">
      <svg
        width={20}
        height={20}
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        viewBox="0 0 24 24"
        {...props}
      >
        <path d="M3 7V5c0-1.1.9-2 2-2h2M17 3h2c1.1 0 2 .9 2 2v2M21 17v2c0 1.1-.9 2-2 2h-2M7 21H5c-1.1 0-2-.9-2-2v-2" />
        <rect width={7} height={5} x={7} y={7} rx={1} />
        <rect width={7} height={5} x={10} y={12} rx={1} />
      </svg>
    </Tooltip>
  )
}

const UnGroupIcon = (props) => {
  return (
    <Tooltip title="Desagrupar">
      <svg
        width={20}
        height={20}
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        viewBox="0 0 24 24"
        {...props}
      >
        <rect width={8} height={6} x={5} y={4} rx={1} />
        <rect width={8} height={6} x={11} y={14} rx={1} />
      </svg>
    </Tooltip>
  )
}

const ArrowDown01 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m3 16 4 4 4-4M7 20V4" />
    <rect width={4} height={6} x={15} y={4} ry={2} />
    <path d="M17 20v-6h-2M15 20h4" />
  </svg>
)

const ArrowDown10 = (props) => (
  <svg
    width={20}
    height={20}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m3 16 4 4 4-4M7 20V4M17 10V4h-2M15 10h4" />
    <rect width={4} height={6} x={15} y={14} ry={2} />
  </svg>
)

export { GroupIcon, UnGroupIcon, ArrowDown01, ArrowDown10 }